import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { vodAdapterLite } from 'shared/utils/adapters/vod-lite';

import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEOS.LIST');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export const defaultParams = {
  sort: {
    order: 'custom',
    direction: 'asc',
  },
  paging: {
    size: 1000,
  },
};


export function listPublic(id, options = {}) {

  _.defaultsDeep(options, defaultParams);

  return function (dispatch) {
    const params = { id, options };
    dispatch(START(params));

    const promise = vodAdapterLite.listItems.listPublic(id, options);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeArrayOfVideos(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.videos.list' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/videos/list-public.js